/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Storypage_Meta_TitleInputs */

const en_fw_storypage_meta_title = /** @type {(inputs: Fw_Storypage_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firefly Wedding Story & Plot Guide (Spoiler-Light)`)
};

const zh_fw_storypage_meta_title = /** @type {(inputs: Fw_Storypage_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萤火之嫁剧情介绍与故事指南（轻剧透）`)
};

/**
* | output |
* | --- |
* | "Firefly Wedding Story & Plot Guide (Spoiler-Light)" |
*
* @param {Fw_Storypage_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_storypage_meta_title = /** @type {((inputs?: Fw_Storypage_Meta_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Storypage_Meta_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_storypage_meta_title(inputs)
	return zh_fw_storypage_meta_title(inputs)
});
export { fw_storypage_meta_title as "fw.storypage.meta_title" }